import React from "react"

import Card from "react-bootstrap/Card"
import ListGroup from "react-bootstrap/ListGroup"
import ListGroupItem from "react-bootstrap/ListGroupItem"
import Table from "react-bootstrap/Table"
import Badge from "react-bootstrap/Badge"

import PropertyImagePath from "./PropertyImagePath"

import propertyListStyles from "./PropertyCards.module.css"

import prThumnail from "../img/about/6971291427-thumnail.jpeg"

function PropertyTitle({ property }) {
  const [floor, type] =
    property.propertyType === "used"
      ? [property.floors, "中古住宅"]
      : property.propertyType === "rental"
      ? [property.floor, "賃貸"]
      : ""

  return (
    <>
      <h3
        className="border rounded-top mb-0 bg-secondary text-white p-1 px-2"
        style={{ fontSize: "1.2rem" }}
      >
        <span>
          <Badge variant="info" style={{ fontSize: "1rem" }}>
            {type}
          </Badge>
          &nbsp;{property.addressShort}&ensp;{floor}
        </span>
        <br />
        <small>
          &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(物件ID:
          {` ${property.propertyId.slice(0, 3)}-${property.propertyId.slice(
            3,
            7
          )}-${property.propertyId.slice(7, 10)}`}
          )
        </small>
      </h3>
    </>
  )
}

function Desc({ property }) {
  let desc
  if (property.propertyType === "used") {
    desc = <UsedDesc property={property} />
  } else if (property.propertyType === "rental") {
    desc = <RentalDesc property={property} />
  }
  // if (property.proertyType === "inv") {
  //   return <InvDesc property={property} />
  // }
  return desc
}

function UsedDesc({ property }) {
  return (
    <tbody>
      <tr>
        <td>間取り：</td>
        <td>{property.layout}</td>
      </tr>
      <tr>
        <td>交通：</td>
        <td>
          {property.access.split("\n").map((str, idx) => (
            <p key={idx}>{str}</p>
          ))}
        </td>
      </tr>
      <tr>
        <td>築年月：</td>
        <td>{property.years}</td>
      </tr>
      <tr>
        <td>建物：</td>
        <td>
          {property.houseArea}m<sup>2</sup>
        </td>
      </tr>
      <tr>
        <td>土地：</td>
        <td>
          {property.landArea}m<sup>2</sup>
        </td>
      </tr>
    </tbody>
  )
}

function RentalDesc({ property }) {
  return (
    <tbody>
      <tr>
        <td>管理費：</td>
        <td>{property.managementExpense}</td>
      </tr>
      <tr>
        <td>敷金：</td>
        <td>{property.rentalDeposit}</td>
      </tr>
      <tr>
        <td>礼金：</td>
        <td>{property.keyMoney}</td>
      </tr>
      <tr>
        <td>間取り：</td>
        <td>{property.layout}</td>
      </tr>
      <tr>
        <td>交通：</td>
        <td>
          {property.access.split("\n").map((str, idx) => (
            <p key={idx}>{str}</p>
          ))}
        </td>
      </tr>
      <tr>
        <td>築年月：</td>
        <td>{property.years}</td>
      </tr>
      <tr>
        <td>面積：</td>
        <td>
          {property.floorArea}m<sup>2</sup>
        </td>
      </tr>
    </tbody>
  )
}

function PropertyCards(props) {
  return props.properties.map((item, idx) => (
    <div key={idx} className="mx-auto" style={{ maxWidth: "767px" }}>
      <PropertyTitle property={item} />

      <Card className="d-flex mb-3 shadow flex-lg-row flex-md-col">
        <Card.Img
          className="h-100 px-1 py-1 mx-auto flex-grow-0 flex-shrink-0"
          variant="top"
          src={PropertyImagePath(item.imgbases[0])}
          style={{ maxWidth: "317px" }}
        />

        <ListGroup
          variant="flush"
          className="px-3 py-1 w-100"
          style={{ borderTop: "none" }}
        >
          <ListGroupItem>
            {item.status === "contract" ? (
              <span
                style={{
                  fontSize: "1.2rem",
                  fontWeight: 600,
                  wordSpacing: "1.0rem",
                  lineHeight: "0.2rem",
                }}
              >
                成約しました
              </span>
            ) : item.status === "pending" ? (
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  fontWeight: 600,
                  wordSpacing: "1.0rem",
                  lineHeight: "0.2rem",
                }}
              >
                商談中
              </span>
            ) : (
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  fontWeight: 600,
                  wordSpacing: "1.0rem",
                  lineHeight: "0.2rem",
                }}
              >
                {item.price || item.rent}万円
              </span>
            )}
          </ListGroupItem>
          {item.status !== "contract" && (
            <>
              <ListGroupItem
                style={{ fontSize: "0.9rem", wordSpacing: "0.6rem" }}
              >
                <Table
                  className={`table-sm table-borderless my-0 ${propertyListStyles.propertyCardSummary}`}
                >
                  <Desc property={item} />
                </Table>
              </ListGroupItem>

              <ListGroupItem
                as="a"
                className="mb-1 text-decoration-none"
                style={{ color: "#004085", backgroundColor: "#b8daff" }}
                href={`${"../house/detail-" + item.propertyId}`}
              >
                詳細をみる
              </ListGroupItem>
            </>
          )}
        </ListGroup>
      </Card>
    </div>
  ))
}

export default PropertyCards
